var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobalGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0a9 9 0 110 18A9 9 0 019 0zM6.527 10c.102 1.906.485 3.563 1.015 4.755.311.7.643 1.173.936 1.451.284.27.458.294.522.294s.238-.023.522-.294c.293-.278.625-.751.936-1.451.53-1.192.913-2.849 1.015-4.755H6.527zm-4.959 0a7.505 7.505 0 004.965 6.083C5.71 14.629 5.146 12.465 5.025 10H1.568zm11.407 0c-.121 2.465-.686 4.629-1.51 6.083A7.504 7.504 0 0016.433 10h-3.457zM6.533 1.916A7.502 7.502 0 001.52 8.5h3.487c.065-2.672.648-5.032 1.527-6.584zM9 1.5c-.064 0-.238.023-.522.294-.293.278-.625.751-.936 1.451-.575 1.295-.98 3.138-1.035 5.255h4.986c-.055-2.117-.46-3.96-1.035-5.255-.311-.7-.643-1.173-.936-1.451C9.238 1.524 9.064 1.5 9 1.5zm2.466.416c.879 1.552 1.463 3.912 1.528 6.584h3.487a7.502 7.502 0 00-5.015-6.584z",
    fill: "#fff"
  })));
}
export default SvgIconGlobalGlobe;